// 世界水準サイトの実測値ベースの共通イージング（調査: Codrops/Awwwards/ICS MEDIA）
export const EASE_EXPO = [0.19, 1, 0.22, 1]; // 見出しスタガー 600–1000ms
export const EASE_QUINT = [0.23, 1, 0.32, 1]; // 画像カーテン/クリップ 800–1500ms
export const EASE_QUART = [0.165, 0.84, 0.44, 1]; // 画像hover 500–800ms
export const EASE_IN_OUT = [0.87, 0, 0.13, 1]; // 対称的な出入り
